'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _get2 = require('babel-runtime/helpers/get');
var _get3 = _interopRequireDefault(_get2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PackageApi = function (_BaseApi) {
  (0, _inherits3.default)(PackageApi, _BaseApi);
  function PackageApi() {
    (0, _classCallCheck3.default)(this, PackageApi);
    return (0, _possibleConstructorReturn3.default)(this, (PackageApi.__proto__ || Object.getPrototypeOf(PackageApi)).call(this, _frontendUtils.endpoints.apiBaseUrl));
  }

  /**
   * This is a helper method to making API requests from that just takes care of the
   * '/data/package' part of the url. Full documentation of this method,
   * is available in the BaseApi class.
   * NOTE: Remember to add `/` at the beginning of your url if you add something more to the path.
   */

  (0, _createClass3.default)(PackageApi, [{
    key: 'makeRequest',
    value: function makeRequest(params) {
      params.url = '/data/package' + params.url;
      return (0, _get3.default)(PackageApi.prototype.__proto__ || Object.getPrototypeOf(PackageApi.prototype), 'makeRequest', this).call(this, params);
    }

    /**
     * Gets the list of subscriptions assigned to the user. Empty list means that given user is not an Enterprise customer.
     * @return {Promise} Resolves, if successful, to the list of user subscriptions. Empty list means that given user is not an Enterprise customer. Otherwise returns an error.
     */
  }, {
    key: 'getSubscriptions',
    value: function getSubscriptions() {
      return this.makeRequest({
        method: 'GET',
        url: '/subscriptions'
      });
    }

    /**
     * Gets the metadata details of a single package.
     * @param packageGuid Guid of the package which metadata should be obtained.
     * @return {Promise}  Resolves, if successful, to the metadata of a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getPackage',
    value: function getPackage(packageGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + packageGuid
      });
    }

    /**
     * Gets the schema details of a single package.
     * @param packageGuid Guid of the package which schema should be obtained.
     * @return {Promise}  Resolves, if successful, to the schema of a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getPackageSchema',
    value: function getPackageSchema(packageGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + packageGuid + '/schema'
      });
    }

    /**
     * Gets the list of snapshots connected to a single package.
     * @param packageGuid Guid of the package which snapshots should be obtained.
     * @return {Promise}  Resolves, if successful, to the list of snapshots of a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getSnapshots',
    value: function getSnapshots(packageGuid, limit) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNumber, limit)) {
        return Promise.reject(new _ParameterError2.default('limit', limit, 'limit number.'));
      }
      return this.makeRequest({
        method: 'GET',
        queryParameters: {
          limit: limit
        },
        url: '/' + packageGuid + '/snapshots'
      });
    }

    /**
     * Gets the details of a single snapshot connected to a single package.
     * @param packageGuid   Guid of the package which contains a given snapshot.
     * @param snapshotGuid  Guid of the snapshot which details should be obtained.
     * @return {Promise}    Resolves, if successful, to the details of a single snapshot connected to a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getSnapshot',
    value: function getSnapshot(packageGuid, snapshotGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(snapshotGuid)) {
        return Promise.reject(new _ParameterError2.default('snapshotGuid', snapshotGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + packageGuid + '/snapshot/' + snapshotGuid
      });
    }

    /**
     * Gets the list of data points of a single snapshot connected to a single package.
     * @param packageGuid   Guid of the package which contains a given snapshot.
     * @param snapshotGuid  Guid of the snapshot which data should be obtained.
     * @return {Promise}    Resolves, if successful, to the list of data of a single snapshot connected to a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getSnapshotData',
    value: function getSnapshotData(packageGuid, snapshotGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(snapshotGuid)) {
        return Promise.reject(new _ParameterError2.default('snapshotGuid', snapshotGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + packageGuid + '/snapshot/' + snapshotGuid + '/data'
      });
    }

    /**
     * Returns a link that can be added for example to HTML anchor element as a link to download snapshot data.
     * @param packageGuid   Guid of the package which contains a given snapshot.
     * @param snapshotGuid  Guid of the snapshot which data should be obtained.
     * @return {String}     If successful, the link to the list of data of a single snapshot connected to a single package. Otherwise returns a ParameterError.
     */
  }, {
    key: 'getSnapshotDataLink',
    value: function getSnapshotDataLink(packageGuid, snapshotGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        throw new _ParameterError2.default('packageGuid', packageGuid, 'guid string.');
      }
      if (!ValidationUtils.isGuid(snapshotGuid)) {
        throw new _ParameterError2.default('snapshotGuid', snapshotGuid, 'guid string.');
      }
      return this.apiEndpoint + '/data/package/' + packageGuid + '/snapshot/' + snapshotGuid + '/data';
    }

    /**
     * Gets the list of changes between the given data list and previous successful one of a single snapshot connected to a single package.
     * @param packageGuid   Guid of the package which contains a given snapshot.
     * @param snapshotGuid  Guid of the snapshot which data should be obtained.
     * @return {Promise}    Resolves, if successful, to the list of changes between the the data list and the previous seccuessful one of a single snapshot connected to a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getSnapshotDiff',
    value: function getSnapshotDiff(packageGuid, snapshotGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(snapshotGuid)) {
        return Promise.reject(new _ParameterError2.default('snapshotGuid', snapshotGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + packageGuid + '/snapshot/' + snapshotGuid + '/diff'
      });
    }

    /**
     * Returns a link that can be added for example to HTML anchor element as a link to download snapshot diff.
     * @param packageGuid   Guid of the package which contains a given snapshot.
     * @param snapshotGuid  Guid of the snapshot which diff should be obtained.
     * @return {String}     If successful, the link to the list of diffs of a single snapshot connected to a single package. Otherwise returns a ParameterError.
     */
  }, {
    key: 'getSnapshotDiffLink',
    value: function getSnapshotDiffLink(packageGuid, snapshotGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        throw new _ParameterError2.default('packageGuid', packageGuid, 'guid string.');
      }
      if (!ValidationUtils.isGuid(snapshotGuid)) {
        throw new _ParameterError2.default('snapshotGuid', snapshotGuid, 'guid string.');
      }
      return this.apiEndpoint + '/data/package/' + packageGuid + '/snapshot/' + snapshotGuid + '/diff';
    }

    /**
     * Gets the details of a single source connected to a single package.
     * @param packageGuid Guid of the package which contains a given snapshot.
     * @param sourceGuid  Guid of the source which details should be obtained.
     * @return {Promise}  Resolves, if successful, to the details of a single source connected to a single package. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'getSource',
    value: function getSource(packageGuid, sourceGuid) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(sourceGuid)) {
        return Promise.reject(new _ParameterError2.default('sourceGuid', sourceGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + packageGuid + '/source/' + sourceGuid
      });
    }

    /**
     * Adds a new source URL to the given package.
     * @param packageGuid Guid of the package where the URL should be added.
     * @param sourceUrl   URL addess that should be added to the package.
     * @return {Promise}  Resolves, if successful, with the result details for this operation. Otherwise returns a ParameterError or ResponseError.
     */
  }, {
    key: 'addSource',
    value: function addSource(packageGuid, sourceUrl) {
      if (!ValidationUtils.isGuid(packageGuid)) {
        return Promise.reject(new _ParameterError2.default('packageGuid', packageGuid, 'guid string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(sourceUrl)) {
        return Promise.reject(new _ParameterError2.default('sourceUrl', sourceUrl, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'GET',
        queryParameters: {
          url: sourceUrl
        },
        url: '/' + packageGuid + '/source'
      });
    }
  }]);
  return PackageApi;
}(_BaseApi3.default);
exports.default = PackageApi;